import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition } from '@wix/sdk-types';
import { aggregateDataItems as universalAggregateDataItems, bulkInsertDataItemReferences as universalBulkInsertDataItemReferences, bulkInsertDataItems as universalBulkInsertDataItems, bulkRemoveDataItemReferences as universalBulkRemoveDataItemReferences, bulkRemoveDataItems as universalBulkRemoveDataItems, bulkSaveDataItems as universalBulkSaveDataItems, bulkUpdateDataItems as universalBulkUpdateDataItems, countDataItems as universalCountDataItems, getDataItem as universalGetDataItem, insertDataItem as universalInsertDataItem, insertDataItemReference as universalInsertDataItemReference, isReferencedDataItem as universalIsReferencedDataItem, queryDataItems as universalQueryDataItems, queryDistinctValues as universalQueryDistinctValues, queryReferencedDataItems as universalQueryReferencedDataItems, removeDataItem as universalRemoveDataItem, removeDataItemReference as universalRemoveDataItemReference, replaceDataItemReferences as universalReplaceDataItemReferences, saveDataItem as universalSaveDataItem, truncateDataItems as universalTruncateDataItems, updateDataItem as universalUpdateDataItem, } from './data-v2-data-item-items.universal';
export const __metadata = { PACKAGE_NAME: '@wix/data' };
export function insertDataItem(httpClient) {
    return (options) => universalInsertDataItem(options, 
    // @ts-ignore
    { httpClient });
}
export function updateDataItem(httpClient) {
    return (_id, options) => universalUpdateDataItem(_id, options, 
    // @ts-ignore
    { httpClient });
}
export function saveDataItem(httpClient) {
    return (options) => universalSaveDataItem(options, 
    // @ts-ignore
    { httpClient });
}
export function getDataItem(httpClient) {
    return (dataItemId, options) => universalGetDataItem(dataItemId, options, 
    // @ts-ignore
    { httpClient });
}
export function removeDataItem(httpClient) {
    return (dataItemId, options) => universalRemoveDataItem(dataItemId, options, 
    // @ts-ignore
    { httpClient });
}
export function truncateDataItems(httpClient) {
    return (options) => universalTruncateDataItems(options, 
    // @ts-ignore
    { httpClient });
}
export function queryDataItems(httpClient) {
    return (options) => universalQueryDataItems(options, 
    // @ts-ignore
    { httpClient });
}
export function aggregateDataItems(httpClient) {
    return (options) => universalAggregateDataItems(options, 
    // @ts-ignore
    { httpClient });
}
export function countDataItems(httpClient) {
    return (options) => universalCountDataItems(options, 
    // @ts-ignore
    { httpClient });
}
export function queryDistinctValues(httpClient) {
    return (options) => universalQueryDistinctValues(options, 
    // @ts-ignore
    { httpClient });
}
export function bulkInsertDataItems(httpClient) {
    return (options) => universalBulkInsertDataItems(options, 
    // @ts-ignore
    { httpClient });
}
export function bulkUpdateDataItems(httpClient) {
    return (options) => universalBulkUpdateDataItems(options, 
    // @ts-ignore
    { httpClient });
}
export function bulkSaveDataItems(httpClient) {
    return (options) => universalBulkSaveDataItems(options, 
    // @ts-ignore
    { httpClient });
}
export function bulkRemoveDataItems(httpClient) {
    return (options) => universalBulkRemoveDataItems(options, 
    // @ts-ignore
    { httpClient });
}
export function queryReferencedDataItems(httpClient) {
    return (options) => universalQueryReferencedDataItems(options, 
    // @ts-ignore
    { httpClient });
}
export function isReferencedDataItem(httpClient) {
    return (options) => universalIsReferencedDataItem(options, 
    // @ts-ignore
    { httpClient });
}
export function insertDataItemReference(httpClient) {
    return (options) => universalInsertDataItemReference(options, 
    // @ts-ignore
    { httpClient });
}
export function removeDataItemReference(httpClient) {
    return (options) => universalRemoveDataItemReference(options, 
    // @ts-ignore
    { httpClient });
}
export function bulkInsertDataItemReferences(httpClient) {
    return (options) => universalBulkInsertDataItemReferences(options, 
    // @ts-ignore
    { httpClient });
}
export function bulkRemoveDataItemReferences(httpClient) {
    return (options) => universalBulkRemoveDataItemReferences(options, 
    // @ts-ignore
    { httpClient });
}
export function replaceDataItemReferences(httpClient) {
    return (options) => universalReplaceDataItemReferences(options, 
    // @ts-ignore
    { httpClient });
}
export const onDataItemCreated = EventDefinition('wix.data.v2.data_item_created', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [{ path: 'metadata.eventTime' }],
    },
]), ['entity.data']))();
export const onDataItemUpdated = EventDefinition('wix.data.v2.data_item_updated', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [{ path: 'metadata.eventTime' }],
    },
]), ['entity.data']))();
export const onDataItemDeleted = EventDefinition('wix.data.v2.data_item_deleted', true, (event) => renameKeysFromRESTResponseToSDKResponse(transformPaths(event, [
    {
        transformFn: transformRESTTimestampToSDKTimestamp,
        paths: [{ path: 'metadata.eventTime' }],
    },
]), ['entity.data']))();
export { ACTION, Action, BulkActionType, Environment, SortOrder, WebhookIdentityType, } from './data-v2-data-item-items.universal';
//# sourceMappingURL=data-v2-data-item-items.public.js.map